namespace $.$$ {

	export class $shm_dashboard_opencode_app extends $.$shm_dashboard_opencode_app {
		private dashboard_session_pending = new Map< string, string >
		private dashboard_session_target = new Map< string, $shm_ba_dashboard_model >

		agent_name() { return 'М+ Агент' }

		opencode_agent_id() { return 'hitalama-ba-dashboard' }

		agent_storage_namespace() {
			return `dashboard_opencode:${ this.user_id() }`
		}

		user_id() {
			return this.$.$shm_ba_pb.user_id() || ''
		}

		auth_token() {
			const token = this.$.$shm_ba_pb.auth_user_token() || ''
			if( !token ) return ''
			if( this.$.$shm_ba_pb.auth_valid( token ) !== true ) return ''
			return this.$.$shm_ba_pb.auth_user_token() || ''
		}

		gateway_url() {
			const hostname = this.$.$mol_dom_context.location.hostname
			const url = hostname === 'localhost' || hostname === '127.0.0.1'
				? `http://${ hostname }:4098`
				: new URL( '/opencode-api', this.$.$mol_dom_context.location.origin ).toString().replace( /\/$/, '' )
			this.$.$shm_opencode_api.credentialed( url, true )
			this.$.$shm_opencode_api.authenticator( url, ()=> this.gateway_auth_async( this.auth_token() ) )
			this.$.$shm_opencode_api.header_provider( url, ()=> {
				const token = this.$.$shm_ba_pb.auth_user_token() || ''
				const headers: Record< string, string > = {}
				if( token ) headers.Authorization = `Bearer ${ token }`
				return headers
			} )
			return url
		}

		async gateway_auth_async( token: string ) {
			const response = await fetch( `${ this.gateway_url() }/auth`, {
				method: 'POST',
				credentials: 'include',
				headers: { Authorization: `Bearer ${ token }` },
			} )
			if( !response.ok ) throw new Error( `М+ Агент: авторизация не удалась (${ response.status })` )
			return true
		}

		@ $mol_mem_key
		gateway_auth( token: string ) {
			return $mol_wire_sync( this ).gateway_auth_async( token )
		}

		override server_url( next?: string ) {
			if( next !== undefined ) return next
			const token = this.auth_token()
			if( !token ) return ''
			this.gateway_auth( token )
			return this.gateway_url()
		}

		opencode_tags_key( id: string ) {
			return `shm_dashboard_opencode_tags:${ this.user_id() }:${ id }`
		}

		opencode_queue_key( id: string ) {
			return `shm_dashboard_opencode_queue:${ this.user_id() }:${ id }`
		}

		opencode_instruction_key( id: string ) {
			return `shm_dashboard_opencode_instruction:v2:${ this.user_id() }:${ id }`
		}

		opencode_instruction_sent( id: string, next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( this.opencode_instruction_key( id ), next ) ?? false
		}

		opencode_instruction_ensure( id: string ) {
			if( this.opencode_instruction_sent( id ) ) return
			$mol_wire_sync( $shm_opencode_api ).send_prompt(
				this.server_url(), id, this.session_create_instructions(), null, true, this.opencode_agent_id(),
			)
			this.opencode_instruction_sent( id, true )
		}

		agent_session_create( title: string, cwd: string, instructions: string ) {
			const result = ( $shm_opencode_app.prototype.agent_session_create as (
				this: unknown,
				title: string,
				cwd: string,
				instructions: string,
			)=> { thread: $shm_agent_session }
			).call( this, title, cwd, instructions )
			this.opencode_instruction_sent( result.thread.id, true )
			return result
		}

		async agent_session_create_async( title: string, cwd: string, instructions: string ) {
			const result = await ( $shm_opencode_app.prototype.agent_session_create_async as (
				this: unknown,
				title: string,
				cwd: string,
				instructions: string,
			)=> Promise< { thread: $shm_agent_session } >
			).call( this, title, cwd, instructions )
			this.opencode_instruction_sent( result.thread.id, true )
			return result
		}

		opencode_before_send( id: string ) {
			( $shm_opencode_app.prototype.opencode_before_send as (
				this: unknown,
				id: string,
			)=> void ).call( this, id )
			this.opencode_instruction_ensure( id )
		}

		sessions_page_visible() {
			return !this.dashboard()
		}

		sessions_pick_visible() {
			return false
		}

		session_create_name( title: string ) {
			return this.dashboard() ? `Дашборд: ${ this.dashboard_title() }` : title
		}

		session_create_instructions() {
			const lines = [
				'Контекст М+ Агента:',
				'Ты работаешь внутри приложения «Мониторинг+».',
			]
			if( this.dashboard() ) lines.push(
				`dashboard_id: ${ JSON.stringify( this.dashboard_id() ) }`,
				`dashboard_title: ${ JSON.stringify( this.dashboard_title() ) }`,
				`Во все hitalama_ba tools передавай dashboard_id: ${ JSON.stringify( this.dashboard_id() ) }.`,
				'Используй MCP server hitalama_ba: dashboard_context, report_list, report_create, report_rename, report_delete, report_select, report_get_code, report_set_code, filter_set.',
			)
			lines.push( $shm_agent_message_chart_instruction() )
			lines.push( $shm_ba_agent_message_posts_instruction() )
			return lines.join( '\n' )
		}

		opencode_message_visible( message: $shm_opencode_api_message ) {
			const role = message.info.role || message.info.type || ''
			if( role !== 'user' ) return true
			return !message.parts.some( part => {
				if( part.type !== 'text' ) return false
				const text = String( part.text ?? '' )
				return text.startsWith( 'Контекст М+ Агента:' ) || text.startsWith( 'Контекст дашборда:' )
			} )
		}

		@ $mol_mem
		override session_id( next?: string ) {
			const dashboard = this.dashboard()
			if( dashboard ) {
				const dashboard_id = this.dashboard_id()
				if( next !== undefined ) {
					if( next.startsWith( 'pending-create:' ) ) {
						this.dashboard_session_pending.set( dashboard_id, next )
						this.dashboard_session_target.set( next, dashboard )
						return next
					}
					const pending = this.dashboard_session_pending.get( dashboard_id )
					this.dashboard_session_pending.delete( dashboard_id )
					if( pending ) this.dashboard_session_target.delete( pending )
					return dashboard.opencode_session_id( next )
				}
				return this.dashboard_session_pending.get( dashboard_id ) || dashboard.opencode_session_id()
			}
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'agent_session', next || null )
				return next
			}

			const id = this.$.$mol_state_arg.value( 'agent_session' ) || ''
			return id
		}

		pending_create_adopt( temporary: string, target_session: $shm_agent_session ) {
			const dashboard = this.dashboard_session_target.get( temporary )
			if( dashboard ) dashboard.opencode_session_id( target_session.id )
			const target = ( $shm_agent_app.prototype.pending_create_adopt as (
				this: $shm_agent_app,
				temporary: string,
				target_session: $shm_agent_session,
			)=> string ).call( this as unknown as $shm_agent_app, temporary, target_session )
			this.dashboard_session_target.delete( temporary )
			for( const [ dashboard_id, pending ] of this.dashboard_session_pending ) {
				if( pending === temporary ) this.dashboard_session_pending.delete( dashboard_id )
			}
			return target
		}

		session_arg( id: string ) {
			return { agent_session: id }
		}

	}

}
